<template>
  <!--
    The brand's retro scoreboard tile. Single line on narrow screens, two
    lines (label over value) once the panel is wide enough. `wide` names the
    breakpoint where the layout switches, matching the host card's tables.
  -->
  <div v-bind="$attrs" :class="shell">
    <slot name="label" />
    <slot />
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";

defineOptions({ inheritAttrs: false });

const props = withDefaults(defineProps<{ wide?: "md" | "xl" }>(), { wide: "md" });

const BASE =
  "isolate font-digi text-accent-txt bg-accent rounded-md shadow-lg ring-1 ring-black/10 px-3 py-1.5 flex items-center gap-x-3 text-base whitespace-nowrap";

const shell = computed(() =>
  props.wide === "xl"
    ? `${BASE} xl:px-4 xl:py-2 xl:block xl:text-2xl xl:text-right`
    : `${BASE} md:px-4 md:py-2 md:block md:text-2xl md:text-right`,
);
</script>
